import { sanitizeDecimalInput } from './decimalInput';

/**
 * Returns the rate as typed - `0.75` for 0.75%, not `0.0075`. An empty field also reads as 0 and 0%
 * is a valid APY, so a required-field check has to test the raw string rather than this number.
 */
export const parsePercent = (raw: string): number => {
  const parsed = Number(sanitizeDecimalInput(raw));

  return Number.isNaN(parsed) ? 0 : parsed;
};
